import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import find from 'lodash/find';

import { Select, SelectContent, SelectTrigger, SelectItem, SelectValue } from '@ps-design-system/components/Select';

import { formatCreditCard, NEW_CARD } from './utils';

const CreditCardSelect = ({ cards, setSelectedCard, selectedCard }) => {
  const cardOptions = useMemo(() => {
    const cardOptions = map(cards, (card) => {
      return {
        label: formatCreditCard(card),
        value: card.id,
        ...card
      };
    });
    return [...cardOptions, NEW_CARD];
  }, [cards]);

  const handleCardChange = useCallback((card_id) => {
    const card = find(cardOptions, (card) => card.id === card_id);
    if (card) {
      setSelectedCard(card);
    }
  }, [selectedCard]);

  return (
    <Select
      name="card"
      onValueChange={handleCardChange}
      value={selectedCard?.id}
    >
      <SelectTrigger
        fullWidth
        data-testing-id="credit-card-select-trigger"
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="border">
        {map(cardOptions, ({ value, label, testingId }) => (
          <SelectItem key={value} value={value} data-testing-id={testingId}>
            {label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

CreditCardSelect.propTypes = {
  cards: PropTypes.array.isRequired,
  setSelectedCard: PropTypes.func,
  selectedCard: PropTypes.object
};

export default CreditCardSelect;
